// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PageSection_page-section__PW4Yd{
  background-color: #FFF;
  height: 100%;
  min-height: calc(100vh - 151px);
  border-radius: 16px;
  padding: 32px;
}

.PageSection_page-section__PW4Yd header{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 33px;
}`, "",{"version":3,"sources":["webpack://./src/components/styles/PageSection.module.css"],"names":[],"mappings":"AAAA;EACI,sBAAsB;EACtB,YAAY;EACZ,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;AACjB;;AAEA;EACI,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACvB","sourcesContent":[".page-section{\n    background-color: #FFF;\n    height: 100%;\n    min-height: calc(100vh - 151px);\n    border-radius: 16px;\n    padding: 32px;\n}\n\n.page-section header{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 33px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page-section": `PageSection_page-section__PW4Yd`
};
export default ___CSS_LOADER_EXPORT___;
